'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function ServiceError() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      message = _ref.message,
      service = _ref.service;

  this.name = 'ServiceError';
  this.message = message;
  this.service = service;
}

ServiceError.prototype = new Error();

exports.default = ServiceError;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/cep-promise/dist/errors/service.js
// module id = 143
// module chunks = 0